import { Route, Routes, useParams, Navigate } from "react-router-dom"
import TabView from "source/groups/my/groups/TabView"

export default function ConversationsRouter() {
  return (
    <TabView>
      <Routes>
        <Route path="*" element={<ChatIndexRedirect />} />
      </Routes>
    </TabView>
  )
}

function ChatIndexRedirect() {
  const { slug, conversationId } = useParams()
  const targetPath = `/my/groups/${slug}/chat`

  const fragment = conversationId
    ? `#chat=conversations/${conversationId}`
    : null // do not auto-open the Chat drawer

  return <Navigate to={targetPath} state={{ fragment }} replace />
}
